<script>
import resources from './resources'

export default {
  name: 'menu-user',

  mixins: [resources]
}
</script>

<template lang="pug">
  li.user-img(style="margin-top: 5px")
    img.img-circle(:src="user.avatar")
    ul
      li.name
        router-link(:to="{name: settingsRouter}")
          a(href="#") {{ user.name }}
      li.name(data-toggle='collapse', data-target='#menu-password', style='cursor:pointer') Alterar Senha
      change-password
      template(v-if="user.is_employee")
        li(v-for="tenant in tenants", v-if="tenant.id !== user.last_tenant_id")
          a(href="#", @click.prevent="changeTenant(tenant)") {{ tenant.name }}

      li.name(v-if="!routeIsPatient && !routeIsSettings && userIsProfessional")
        a(href="", @click.prevent="professionalToPatient")
          | Menu Paciente
      li.name(v-if="!routeIsProfessional && userIsProfessionalOrCompany")
        a(href="/app/professional/dashboard/index")
          | Menu Profissional
      li.logout
        a(href='#', @click.prevent='doLogout()') Sair
</template>



// WEBPACK FOOTER //
// src/layout/headers/menu/user/user.vue